<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer :title="'Edit Penalty'">
      <form v-on:submit.prevent="doSubmitPenalty">
        <label class="labels">Bill Number *</label>
        <b-form-input disabled :required="true" for-input="billNumber" type="text" name="billNumber" id="billNumber" label="Bill Number" placeholder="Enter Bill Number" v-validate="modelValidations.billNumber" :error="errors.first('billNumber')" v-model="model.billNumber" data-vv-as="billNumber"/><br>
        <label class="labels">Penalty Date *</label>
        <b-form-datepicker
          id="penaltyDate"
          name="penaltyDate"
          disabled
          v-model="penaltyDate"
          v-validate="modelValidations.penaltyDate"
          v-bind:class="errors.has('penaltyDate') ? 'is-invalid':''"
          locale="en-US"
          placeholder="No Date Selected"
        ></b-form-datepicker><br>
        <label class="labels">Amount *</label>
        <b-form-input :required="true" for-input="amount" type="number" name="amount" id="amount" label="Amount" placeholder="Enter Amount" v-validate="modelValidations.amount" :error="errors.first('amount')" v-model="model.amount" data-vv-as="amount"/><br>
        <label class="labels">Traffic Violation Photo *</label>
        <div class="expander">
          <b-form-file v-if="model.photoBill1 === null" :required="false" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
          </b-form-file>
          <b-form-input v-else disabled :required="false" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
          </b-form-input>
            <!-- <div class="input-group">
              <div class="custom-file">
                <b-form-input type="file" class="custom-file-input" ref="photoBill1" @change="onFileSelectedPhoto" id="photoinputGroupFile" accept="image/jpeg, image/png, image/jpg" name="photoBill1" v-validate="modelValidations.photoBill1" :error="errors.first('photoBill1')" data-vv-as="photoBill1"/>
                <label class="custom-file-label" for="photoinputGroupFile">{{model.photoBill1 !== null ? model.photoBill1.name : 'Choose file'}}</label>
              </div>
              <div v-if="model.photoBill1 !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
              </div>
            </div> -->
          <!-- </b-form-file> -->
        </div><br>
        <label class="labels">bill status *</label>
        <div class="form-group" :required="true" v-bind:class="errors.has('status') ? 'has-error':''">
          <b-form-select name="status" v-model="model.status" v-validate="modelValidations.status" v-bind:class="errors.has('status') ? 'is-invalid':''" :error="errors.first('status')" :options="statusList">
          </b-form-select>
        </div>
        <div v-if="model.status === 'Paid' && model.status !== 'New'">
          <label class="labels mt-3">Bill Photo </label>
          <div class="expander">
            <b-form-file :required="false" label="Photo" v-model="model.photoBill2">
            </b-form-file>
          </div><br>
        </div>
        <label class="labels">Note </label>
        <b-form-input :required="false" for-input="note" type="text" name="note" id="note" label="Note" placeholder="Enter Note" v-validate="modelValidations.note" :error="errors.first('note')" v-model="model.note" data-vv-as="note"/><br>
        <!-- <label>Payment Status *</label>
        <b-form-radio-group
          v-model="model.status"
          :options="paymentStatus"
          value-field="value"
          text-field="text"
        ></b-form-radio-group><br> -->
        <b-button variant="warning" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Update </b-button>
        <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
      </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    props: {
      vehicleUuid: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        apiUrl: {
          vehicleBillInfo: window.AppConfig.apiUrl + 'vehicle-bill-info',
          vehicleBill: window.AppConfig.apiUrl + 'vehicle-bill-info?vehicle_uuid=' + this.vehicleUuid + '&type=Penalty',
        },
        type: null,
        model: {
          uuid: null,
          options: [],
          dueDate: null,
          type: "Penalty",
          vehicle: null,
          billNumber: null,
          penaltyDate: null,
          amount: 0,
          photoBill1: null,
          photoBill2: null,
          note: "",
          status: "New",
          // status: false
        },
        paymentStatus: [
          {
            value: 'false',
            text: 'Not paid yet'
          },
          {
            value: 'true',
            text: 'Already paid'
          }
        ],
        statusList: [
          {
            value: 'New',
            text: 'Waiting For Payment'
          },
          {
            value: 'Paid',
            text: 'Paid'
          }
        ],
        penaltyDate: null,
        modelValidations: {
          billNumber: {
            required: true
          },
          penaltyDate: {
            required: true
          },
          amount: {
            required: true
          },
          photoBill1: {
            required: true
          },
          photoBill2: {
            required: true
          },
          status: {
            required: true
          }
        }
      }
    },
    mounted () {
      this.getPenaltyBill()
    },
    methods: {
      getPenaltyBill () {
        this.isLoading = true
        this.$http.get(this.apiUrl.vehicleBill + '?vehicle_uuid=' + this.vehicleUuid + '&order=createdAt').then(resp => {
          resp.data._embedded.vehicleBillInfo.forEach(data => {
            this.vehicleRequestList.push(data)
          })
          this.isLoading = false
        })
      },
      doSubmitPenalty() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true
            // let penaltyDate = {name: "PenaltyDate", value: this.penaltyDate};
            // this.model.options.push(penaltyDate)

            let formData = new FormData()
            formData.append('billNumber', this.model.billNumber)
            formData.append('amount', this.model.amount)
            formData.append('dueDate', this.penaltyDate)
            formData.append('status', this.model.status)
            formData.append('note', this.model.note ? this.model.note : '-')
            if (this.model.photoBill2 !== null) {
              formData.append('photoBill2', this.model.photoBill2, this.model.photoBill2.name)
            } else if (this.model.photoBill2 === null) {
              
            }
            // if (this.model.photoBill1 === null) {
            //   formData.append('photoBill1', this.model.photoBill1)
            // } else {

            // }
            // if (this.model.status === 'Paid') {
            //   formData.append('photoBill2', this.model.photoBill2)
            // }
            if (this.model.uuid !== null) {
              let model = {}
              Object.keys(this.model).forEach(element => {
                if (element !== 'uuid') {
                  model[element] = this.model[element]
                }
              })
              this.$http.patch(this.apiUrl.vehicleBillInfo + '/' + this.model.uuid, formData).then(response => {
                this.isLoading = false
                this.$store.dispatch('notification/success', 'Penalty data successfully updated.')
                this.$emit('getPenaltyBill')
                this.hideModal()
                this.resetData()
              }).catch(error => {
                this.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      getDate (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD')
        } else {
          return '-'
        }
      },
      resetData () {
        this.model.uuid = null
        this.penaltyDate = null
        this.model.photoBill1 = null
        this.model.photoBill2 = null
        this.model.note = null
        this.model.amount = 0
        this.model.status = null
        this.model.billNumber = null
        this.$validator.reset()
      },
      showModal(row) {
        this.model.uuid = row.uuid
        this.penaltyDate = row.dueDate !== null ? this.getDate(row.dueDate) : ''
        this.model.note = row.note !== null && row.note !== '' && row.note !== 'null' ? row.note : '-'
        this.model.amount = row.amount
        this.model.billNumber = row.billNumber
        this.model.photoBill2 = null
        this.model.photoBill1 = row.vehicleBillPhoto !== null ? row.vehicleBillPhoto[0].url : null
        this.model.status = row.status
        this.$validator.reset();
        this.$refs['my-modal'].show()
      },
      onFileSelectedPhoto (event) {
        this.model.photo = event.target.files[0]
      },
      clearImagePhoto () {
        this.$refs.photoBill1.value = ''
        this.model.photoBill1 = null
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      }
    }
  }
</script>